<template>
  <div v-if="!isVideo" class="v-media">
    <img
      :src="src"
      :alt="alt"
      :key="src"
      :style="imgStyles"
    >
    <div class="v-media__spinner-wrapper">
      <div v-if="!isLoaded && !isError" class="v-media__spinner"><div></div><div></div><div></div><div></div></div>
      <div v-if="isError" class="v-media__error"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="32" style="overflow:visible;enable-background:new 0 0 32 32" viewBox="0 0 32 32" width="32" xml:space="preserve"><g><g id="Error_1_"><g id="Error"><circle cx="16" cy="16" id="BG" r="16" style="fill:#FFF;"/><path d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z" id="Exclamatory_x5F_Sign" style="fill:#000;"/></g></g></g></svg></div>
    </div>
  </div>
  <div v-else class="v-media">
    <video
      :src="src"
      :key="src"
      controls
    ></video>
  </div>
</template>

<script>
export default {
  props: {
    alt: {
      default: '',
      type: String
    },
    src: String,
    fit: {
      default: 'cover',
      type: String
    }
  },

  data () {
    return {
      isError: false,
      isLoaded: false
    }
  },

  computed: {
    imgStyles () {
      return [
        { 'object-fit': this.fit },
        { 'opacity': this.isLoaded ? '1' : '0' }
      ]
    },

    isVideo () {
      return this.src.includes('.mp4')
    }
  },

  created () {
    const img = new Image()
    img.src = this.src
    img.onload = () => {
      this.isLoaded = true
    }
    img.onerror = () => {
      this.isError = true
    }
  }
}
</script>

<style lang="scss">
.v-media {
  min-height: 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 100%;
    transition: opacity 0.6s;
    width: 100%;
    max-height: 100vh;
  }

  video {
    height: 100%;
    width: 100%;
    max-height: 100vh;
  }

  &__spinner-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__error {
    svg {
      margin: 0 auto;
    }
  }

  &__spinner {
    display: block;
    margin: 0 auto;
    width: 40px;
    height: 40px;

    div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 32px;
      height: 32px;
      margin: 4px;
      border: 4px solid #eee;
      border-radius: 50%;
      animation: rotate 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #eee transparent transparent transparent;

      &:nth-child(1) {
        animation-delay: -0.45s;
      }
      &:nth-child(2) {
        animation-delay: -0.3s;
      }
      &:nth-child(3) {
        animation-delay: -0.15s;
      }
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
